import FormBase from "../FormBase";
import FormFieldAttachmentBase from "../../forms/FormFieldAttachmentBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";

export enum EAttachmentMedicoParceiro {
    CopiaCarteiraConselho = 32,
    CopiaRG = 33,
    CertidaoEticaProfissional = 34,
    CertidaoQuitacao = 35,
    CopiaDiplomaGraduacaoMedicina = 36,
    CopiaTituloEspecialista = 37,
    CopiaResidenciaMedica = 38,
    CurriculoResumidoAtualizado = 39,
    Foto = 40,
    ComprovanteVacinaCovid = 59
}

export default class AttachmentForm implements FormBase {

    CertidaoEticaProfissional: FormFieldAttachmentBase;
    CertidaoQuitacao: FormFieldAttachmentBase;
    CopiaCRM: FormFieldAttachmentBase;
    CopiaDiplomaGraduacaoMedicina: FormFieldAttachmentBase;
    CopiaRG: FormFieldAttachmentBase;
    CopiaTituloEspecialista: FormFieldAttachmentBase;
    CopiaResidenciaMedica: FormFieldAttachmentBase;
    CurriculoResumidoAtualizado: FormFieldAttachmentBase;
    Foto: FormFieldAttachmentBase;
    ComprovanteVacinaCovid: FormFieldAttachmentBase;


    constructor() {
        this.CertidaoEticaProfissional = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CertidaoEticaProfissional);
        this.CertidaoQuitacao = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CertidaoQuitacao);
        this.CopiaCRM = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CopiaCarteiraConselho);
        this.CopiaDiplomaGraduacaoMedicina = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CopiaDiplomaGraduacaoMedicina);
        this.CopiaRG = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CopiaRG);
        this.CopiaTituloEspecialista = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMedicoParceiro.CopiaTituloEspecialista, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CopiaResidenciaMedica = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMedicoParceiro.CopiaResidenciaMedica, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CurriculoResumidoAtualizado = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.CurriculoResumidoAtualizado);
        this.Foto = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMedicoParceiro.Foto);
        this.ComprovanteVacinaCovid = new FormFieldAttachmentBase([],1, [], EAttachmentMedicoParceiro.ComprovanteVacinaCovid);
    }

    ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value: any): string {
        if (this.CopiaTituloEspecialista.Values.length === 0 && this.CopiaResidenciaMedica.Values.length === 0) {
            return "Por favor, insira a Cópia do Titulo de Especialista ou Residência Médica."
        } else {
            this.CopiaTituloEspecialista.Error = "";
            this.CopiaResidenciaMedica.Error = "";
            return "";
        }
    }

    static NewInstance(): AttachmentForm {
        return new AttachmentForm();
    }

    CallInsertOrUpdateApi(): Promise<boolean> {
        return Promise.resolve(true);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;
        let maxLengthIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }

            if(element !== null) {

                let files = this.GetFieldByName(element).Values;

                for (let indexFile = 0; indexFile < files.length; indexFile++) {
                    const file = files[indexFile];

                    if (file.ErrorMessage !== null && file.ErrorMessage !== "") {
                        formIsValid = false;
                        maxLengthIsValid = false;
                    }
                }
            }
        }

        if (!formIsValid) {
            if(!maxLengthIsValid){
                return "O tamanho do arquivo é maior do que o permitido, impossibilitando avançar. Favor remover e inserir arquivo do tamanho de até 3MB."
            }else{
                return "Por favor, insira os anexos obrigatórios."
            }
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldAttachmentBase {
        switch (name) {

            case "CertidaoEticaProfissional":
                return this.CertidaoEticaProfissional

            case "CertidaoQuitacao":
                return this.CertidaoQuitacao

            case "CopiaCRM":
                return this.CopiaCRM

            case "CopiaDiplomaGraduacaoMedicina":
                return this.CopiaDiplomaGraduacaoMedicina

            case "CopiaRG":
                return this.CopiaRG

            case "CopiaTituloEspecialista":
                return this.CopiaTituloEspecialista

            case "CopiaResidenciaMedica":
                return this.CopiaResidenciaMedica

            case "CurriculoResumidoAtualizado":
                return this.CurriculoResumidoAtualizado

            case "Foto":
                return this.Foto

            case "ComprovanteVacinaCovid":
                return this.ComprovanteVacinaCovid

            default:
                return new FormFieldAttachmentBase([], 0, []);
        }
    }
};
